<template>
  <div class="home">
    <MyHeader title="policy"></MyHeader>
    <div class="content">
      <div class="left">
        <div class="item-title">珠三角核心区</div>
        <div class="item-content">
          <ul>
            <li v-for="li in centerList">
              <div class="li-title" :data-title="li.city">
                <span>{{ li.sum }}</span>
              </div>
              <div class="li-content">
                <div v-for="line in li.list" :class="'li-line line-' + line.star">
                  <i class="i1"></i>
                  <i class="i2"></i>
                  <i class="i3"></i>
                  <span>{{ line.name }}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="center">
        <!-- <TopCount ref="TopCount" :type="mapCode > 1 ? 'Guangdong' : 'Country'" :pointName="mapName"></TopCount> -->
        <div class="title">广东省制造业高质量发展“十四五”规划十大战略性支柱产业空间布局图</div>
        <GzMap
          @mapCode="changeMapCode"
          @loading="(e) => (loading = e)"
          :mapData="{
            centerList,
            eastList,
            wList,
            nList,
          }"
        ></GzMap>
        <div class="ul-box">
          <div class="item-title">沿海经济-西翼</div>
          <div class="item-content">
            <ul>
              <li v-for="li in wList">
                <div class="li-title" :data-title="li.city">
                  <span>{{ li.sum }}</span>
                </div>
                <div class="li-content">
                  <div v-for="line in li.list" :class="'li-line line-' + line.star">
                    <i class="i1"></i>
                    <i class="i2"></i>
                    <i class="i3"></i>
                    <span>{{ line.name }}</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="right">
        <ElementSelect
          :val="selectId"
          @val="
            (e) => {
              selectId = e;
            }
          "
          :options="options"
        />
        <div class="ul-box">
          <div class="item-title">沿海经济-北翼</div>
          <div class="item-content">
            <ul>
              <li v-for="li in nList">
                <div class="li-title" :data-title="li.city">
                  <span>{{ li.sum }}</span>
                </div>
                <div class="li-content">
                  <div v-for="line in li.list" :class="'li-line line-' + line.star">
                    <i class="i1"></i>
                    <i class="i2"></i>
                    <i class="i3"></i>
                    <span>{{ line.name }}</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div class="ul-box">
          <div class="item-title">沿海经济-东翼</div>
          <div class="item-content">
            <ul>
              <li v-for="li in eastList">
                <div class="li-title" :data-title="li.city">
                  <span>{{ li.sum }}</span>
                </div>
                <div class="li-content">
                  <div v-for="line in li.list" :class="'li-line line-' + line.star">
                    <i class="i1"></i>
                    <i class="i2"></i>
                    <i class="i3"></i>
                    <span>{{ line.name }}</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- <EleDialog :title="dialogTitle" :visible.sync="showDialog">
      <div class="filter-box">
        <ElementSelect
          :val="search.cityName"
          :options="optionCity"
          clearable
          @val="changeVal($event, 'cityName')"
          v-if="!apiName.includes('City')"
          size="middle"
        />
        <ElementSelect
          :val="search.year"
          :options="optionYear"
          clearable
          @val="changeVal($event, 'year')"
          v-else
          size="middle"
        />
        <EleInput v-model="search.enterpriseName" placeholder="请输入企业名称" />
      </div>
      <ComTable
        :tableCol="tableCol"
        :tableData="tableData"
        :pager="pager"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      />
    </EleDialog> -->
    <!--<div class="loading" v-loading="loading" v-if="loading"-->
    <!--     element-loading-background="rgba(0, 0, 0, 0)">-->
    <!--</div>-->
  </div>
</template>

<script>
import { getTime } from '@/utils';
import GzMap from './comp/map';
import ComTable from '../../components/ComTable';
import ElementSelect from '../../components/element-select';
import cityJson from '../home/cityJson';
import MyHeader from '@/components/Header';
import tmpData from './tmpData';

export default {
  name: 'Market',
  components: {
    MyHeader,
    GzMap,
    ElementSelect,
  },
  data() {
    return {
      isLogin: true,
      pass: '',
      // currentTime: getTime(new Date(), 'yyyy-MM-dd hh:mm:ss'),
      timer: null,
      mapCode: 1,
      mapName: '',
      loading: false,
      showDialog: false,
      dialogTitle: '',
      tableData: [],
      pager: {
        currentPage: 1,
        pageSize: 10,
        total: 22,
      },
      apiName: '',
      search: {
        cityName: '',
        year: '',
        enterpriseName: '',
      },
      selectId: 1,
      options: [
        {
          label: '支柱产业',
          value: 1,
        },
        {
          label: '新兴产业',
          value: 2,
        },
      ],
      optionCity: cityJson,
      optionYear: [
        {
          value: 2022,
          label: 2022,
        },
        {
          value: 2021,
          label: 2021,
        },
      ],
      centerList: [],
      eastList: [],
      wList: [],
      nList: [],
    };
  },
  computed: {
    tableCol() {
      let col = [];
      switch (this.apiName) {
        case 'getSpecialNewEnterpriseList':
        case 'getLitterEnterpriseList':
          col = [
            {
              label: '序号',
              type: 'index',
              maxWidth: 70,
            },
            {
              label: '地市',
              param: 'cityName',
            },
            {
              label: '企业名称',
              param: 'enterpriseName',
              width: 320,
              align: 'left',
            },
          ];
          break;
        case 'getMapCityEnList':
          col = [
            {
              label: '排行',
              param: 'ranking',
              maxWidth: 70,
            },
            {
              label: '企业名称',
              param: 'enterpriseName',
              width: 300,
              align: 'left',
            },
            {
              label: '所属行业',
              param: 'industry',
              width: 160,
              align: 'left',
            },
            {
              label: '营收（万元）',
              param: 'businessIncome',
              width: 80,
              align: 'left',
            },
          ];
          break;
        default:
          break;
      }
      return col;
    },
  },
  watch: {
    mapCode(n) {
      console.log(n, '-mapCode-n');
    },
    selectId() {
      this.changeSelectId();
    },
    isLogin(n) {
      if (n) {
        // let expiredTime = sessionStorage.getItem('expiredTime'),
        //   nowStamp = new Date().getTime(),
        //   lessHour = expiredTime - nowStamp < 1000 * 60 * 60;
        // // if (lessHour) {
        //   setTimeout(() => {
        //     console.log(expiredTime - nowStamp, new Date(), expiredTime, nowStamp, '-in-expiredTime - nowStamp')
        //     this.$message.warning('登录超时，请重新登录！');
        //     sessionStorage.removeItem('expiredTime');
        //     this.isLogin = false;
        //   }, expiredTime - nowStamp)
        // // }
      }
    },
    'search.enterpriseName'(n) {
      this.getData();
    },
  },
  mounted() {
    // this.timer =  setInterval(() => {
    //     this.currentTime = getTime(new Date(), 'yyyy-MM-dd hh:mm:ss');
    //   }, 1000);
    this.busOn();
    this.setTimer();
    this.changeSelectId();
    // let expiredTime = sessionStorage.getItem('expiredTime');
    // let nowStamp = new Date().getTime();
    // if (expiredTime && nowStamp < expiredTime) {
    //   this.isLogin = true;
    // }

    window.onresize = () => {
      this.resizeChart();
    };
  },
  methods: {
    changeSelectId() {
      if (this.selectId === 1) {
        let { centerList, eastList, wList, nList } = tmpData;
        this.centerList = centerList;
        this.eastList = eastList;
        this.wList = wList;
        this.nList = nList;
      } else {
        let { centerList2, eastList2, wList2, nList2 } = tmpData;
        this.centerList = centerList2;
        this.eastList = eastList2;
        this.wList = wList2;
        this.nList = nList2;
      }
    },
    clearSearch() {
      this.pager.pageSize = 10;
      this.pager.currentPage = 1;
      this.search = {
        enterpriseName: '',
        provinceName: '',
        cityName: '',
        year: '',
      };
    },
    busOn() {
      this.$bus.$on('showEn500Dialog', (data) => {
        this.dialogTitle =
          data.name + `${data.name.includes('省') || data.name.length > 2 ? '' : '市'}全国民营企业500强名单`;
        this.clearSearch();
        let params = {
          cityName: data.name,
          year: data.year,
        };
        if (data.type === 1) {
          delete params.cityName;
          params.provinceName = data.name;
        }
        this.search = {
          ...this.search,
          ...params,
        };
        this.getData('500强', params);
      });
    },
    handleClickChart(params, name) {
      console.log(params, name, 'pp');
      this.dialogTitle = `${params.name}年${name}${params.seriesName}名单`;
      this.clearSearch();
      this.search.year = params.name;
      this.getData(name, this.search);
      this.show = true;
    },
    changeVal(e, type) {
      this.search[type] = e;
      this.getData();
    },
    handleSizeChange(e) {
      this.pager.pageSize = e;
      this.getData();
    },
    handleCurrentChange(e) {
      this.pager.currentPage = e;
      this.getData();
    },
    changeMapCode(e) {
      this.mapCode = e.code;
      this.mapName = e?.name;
      console.log(e, '-e');
    },
    submit() {
      if (this.pass) {
        if (this.pass !== 'sgsl2022') {
          this.$message.info('密码错误，请重新输入！');
        } else {
          this.isLogin = true;
          let expiredTime = new Date().getTime() + 1000 * 60 * 60 * 12;
          sessionStorage.setItem('expiredTime', expiredTime);
        }
      } else {
        this.$message.info('请输入密码！');
      }
    },
    setTimer() {
      this.timer1 = setInterval(() => {
        this.$nextTick(() => {
          let chartBox = [
            'PrivateEnterprise',
            'barHighTech',
            'barSpecialNew',
            'GDPAndGrowthRate',
            'FixedAssetInvestment',
            'EconomicVolume',
            'MarketSubjectType',
            'MarketMainIndustry',
            'barPrivateTax',
            'barBankFinance',
          ];
          let i = 0;
          chartBox.map((item) => {
            setTimeout(() => {
              // this.$refs[item].setInterData();
            }, i * 100);
            i++;
          });
        });
      }, 5000);
    },
    resizeChart() {
      let chartBox = [
        'PrivateEnterprise',
        'barHighTech',
        'barSpecialNew',
        'GDPAndGrowthRate',
        'FixedAssetInvestment',
        'EconomicVolume',
        'MarketSubjectType',
        'MarketMainIndustry',
        'barPrivateTax',
        'barBankFinance',
      ];
      chartBox.map((item) => {
        for (let key in this.$refs[item].$refs) {
          this.$refs[item].$refs[key].resize();
        }
      });
    },
    getData(name, params) {
      let apiName = this.apiName;
      !name ? (name = this.dialogTitle) : '';
      if (this.dialogTitle.includes('企业中小')) {
        apiName = 'getSpecialNewEnterpriseList';
      }
      if (this.dialogTitle.includes('企业小巨人')) {
        apiName = 'getLitterEnterpriseList';
      }
      if (this.dialogTitle.includes('500强')) {
        apiName = 'getMapCityEnList';
      }
      this.apiName = apiName;
      params = {
        ...params,
        ...this.search,
        pageSize: this.pager.pageSize,
        pageNum: this.pager.currentPage,
      };
      this.search = {
        ...params,
      };
      if (!apiName) return;
      this.$api.screen[apiName](params).then((res) => {
        let { data } = res.data;
        this.tableData = data.records;
        this.pager.total = data.total;
        this.showDialog = true;
      });
    },
  },
  beforeDestroy() {
    this.$bus.$off('showEn500Dialog');
    // sessionStorage.removeItem('expiredTime');
    // clearInterval(this.timer)
    // clearSetInterval(this.timer1)
  },
};
</script>
<style lang="less" scoped>
@font-face {
  font-family: Digital;
  src: url('../../assets/unicode.digital.ttf');
}

.home {
  /*width: 100%;*/
  width: 3200px;
  height: 1080px;
  /*background: #08090e url('../../assets/home/header.gif') no-repeat;*/
  background: url('~img/home/home-bg.jpg') no-repeat;
  background-size: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;

  .time {
    position: absolute;
    top: 50px;
    right: 30px;

    img {
      width: 10px;
      margin-right: 5px;
    }

    span {
      font-family: Digital;
      color: #a2d0f4;
      font-size: 12px;
    }
  }
}

.content {
  display: flex;
  justify-content: space-around;
  padding: 0 15px;
  /*margin-top: 90px;*/
  // margin-top: 20px;
  height: calc(100% - 96px);
  z-index: 11;
  .item-title {
    width: 100%;
    height: 53px;
    // background: linear-gradient(90deg, rgba(148, 222, 255, 0.45), rgba(148, 222, 255, 0));

    background: url('~img/commonImg/policy-c.png') no-repeat;
    background-size: 100% 100%;
    font-size: 22px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #ffffff;
    line-height: 53px;
    display: flex;
    align-items: center;
    padding-left: 41px;
    // &::before {
    //   content: '';
    //   width: 22px;
    //   height: 44px;
    //   display: inline-block;
    //   margin-right: 20px;
    // }
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    margin: 0;
    padding: 0;
    padding-top: 39px;
  }
  li {
    margin-bottom: 26px;
    margin-right: 29px;
    .li-title {
      position: relative;
      height: 26px;
      perspective: 50px;
      margin-bottom: -2px;
      &::after {
        position: absolute;
        left: 0;
        bottom: 0;
        content: attr(data-title);
        font-size: 18px;
        font-family: HYZongYiJ;
        font-weight: 400;
        font-style: italic;
        color: #ffffff;
        text-shadow: 0px 4px 5px #061b2a;
        padding-left: 33px;
        white-space: nowrap;
      }
      &::before {
        position: absolute;
        left: 8px;
        bottom: 0;
        width: 218px;
        height: 18px;
        background: linear-gradient(90deg, #94deff 0%, rgba(148, 222, 255, 0) 100%);
        content: '';
        display: block;
        transform: rotateX(24deg);
        perspective-origin: right top;
      }
      span {
        position: absolute;
        right: 21px;
        bottom: 1px;
        font-size: 20px;
        font-family: Geometr706 BlkCn BT;
        font-weight: 400;
        font-style: italic;
        color: #ffffff;
        text-shadow: 0px 4px 5px rgba(6, 27, 42, 0.65);
      }
    }
    .li-content {
      position: relative;
      box-sizing: border-box;
      width: 210px;
      //   height: 305px;
      background: rgba(20, 26, 38, 0.9);
      border: 2px solid;
      border-image: linear-gradient(90deg, rgba(255, 255, 255, 0.12), rgba(170, 240, 250, 0.12)) 2 2;
      border-radius: 3px;
      padding: 19px 0 21px 19px;
      .li-line {
        display: flex;
        align-items: center;
        + .li-line {
          margin-top: 15px;
        }
        i {
          width: 14px;
          height: 14px;
          display: inline-block;
          background: url('~img/commonImg/policy-star.png') no-repeat;
          background-size: 100% 100%;
          + i {
            margin-left: 4px;
          }
        }
        &.line-1 {
          .i2,
          .i3 {
            opacity: 0.3;
          }
        }
        &.line-2 {
          .i3 {
            opacity: 0.3;
          }
        }
        span {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          text-shadow: 0px 4px 4px rgba(30, 40, 60, 0.6);
          padding-left: 12px;
        }
      }
      &::before,
      &::after {
        position: absolute;
        top: -2px;
        left: 50%;
        transform: translateX(-50%);
        width: 196px;
        height: 4px;
        content: '';
        background: url('~img/commonImg/policy-light.png') no-repeat;
        background-size: 100% 100%;
      }
      &::after {
        top: unset;
        bottom: -2px;
      }
    }
  }

  .center {
    flex: 1;
    position: relative;
    z-index: 1;
    .title {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 24px;
      margin: 39px 0 43px;
      text-align: center;
    }
    .ul-box {
      position: absolute;
      right: 0;
      bottom: 0;
      z-index: 9;
    }

    .item-title {
      // background: linear-gradient(90deg, rgba(11, 134, 217, 0.45), rgba(11, 134, 217, 0));
      // &::before {
      background: url('~img/commonImg/policy-w.png') no-repeat;
      background-size: 100% 100%;
      // }
    }
    li .li-title::before {
      background: linear-gradient(90deg, #0b86d9 0%, rgba(11, 134, 217, 0) 100%);
    }

    .top-count {
      width: calc(100% - 200px);
      margin: auto;
      position: relative;
      z-index: 11;
    }

    .aMap {
      width: 100%;
      position: absolute;
      top: 107px;
      left: 0;
      /*top: 250px;*/
    }

    /*width: 59%;*/
    //  border:1px solid #333;
  }

  .left,
  .right {
    display: flex;
    z-index: 2;
    flex-wrap: wrap;
    // width: 20%;
    // border:1px solid #333;

    > div:first-child {
      // margin-right: 30px;
    }
  }

  .left {
    // width: 31%;
    width: 1228px;
    padding-top: 30px;
    padding-left: 32px;
    margin-right: -29px;
    box-sizing: border-box;
  }

  .right {
    position: relative;
    width: 1211px;
    padding-top: 103px;
    padding-right: 30px;
    margin-left: -45px;
    justify-content: flex-end;

    /deep/ .element-select {
      position: absolute;
      top: 39px;
      left: 65px;
      z-index: 8;
      .el-select {
        width: 138px;
        height: 30px;
      }
    }

    .ul-box {
      .item-title {
        // background: linear-gradient(90deg, rgba(0, 28, 46, 0.45), rgba(0, 28, 46, 0));
        // &::before {
        background: url('~img/commonImg/policy-n.png') no-repeat;
        background-size: 100% 100%;
        //   }
      }
      li .li-title::before {
        background: linear-gradient(90deg, #001c2e 0%, rgba(27, 95, 152, 0) 100%);
      }
      + .ul-box {
        .item-title {
          height: 48px;
          line-height: 48px;
          // background: linear-gradient(90deg, rgba(26, 93, 131, 0.45), rgba(26, 93, 131, 0));
          // &::before {
          background: url('~img/commonImg/policy-e.png') no-repeat;
          background-size: 100% 100%;
          //   }
        }
        li .li-title::before {
          background: linear-gradient(90deg, rgba(26, 93, 131, 1) 0%, rgba(27, 95, 152, 0) 100%);
        }
      }
    }
  }
}

/deep/.ele-dialog {
  .filter-box {
    margin-bottom: 20px;
    .flex-center();
    justify-content: flex-end;

    > div {
      margin-left: 20px;
    }
  }

  .com-table {
    height: calc(100% - 60px);
  }
}

.login-wrap {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  .flex-center();
  justify-content: center;

  .login-box {
    width: 620px;
    height: 220px;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(5px);
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5), 0 0 4px 0 rgba(235, 235, 235, 0.2);
    padding: 20px;
    display: flex;
    justify-content: center;
    flex-direction: column;

    > span {
      color: #fff;
      font-size: 26px;
      text-align: left;
      line-height: 60px;
      margin-top: -10px;
    }
  }

  .password {
    width: 100%;
    .flex-center();
    margin-bottom: 20px;

    /deep/ .el-input {
      width: 85%;
      height: 56px;

      .el-input__inner {
        height: 100% !important;
      }

      .el-input__suffix {
        font-size: 20px;
        margin-right: 10px;
      }
    }

    .el-button {
      margin-left: 20px;
      width: 100px;
      height: 56px;
    }
  }
}

.loading {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(20px);
  /*filter: blur(10px);*/
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
}
</style>
